import React from 'react';
import { Instagram, Facebook, Mail, MapPin, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer style={{
      background: '#0f2314',
      color: 'rgba(255,255,255,0.8)',
      padding: '60px 20px 30px',
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '40px',
        marginBottom: '40px',
      }}>
        {/* Brand */}
        <div>
          <img src="/logo.png" alt="ShuCore.online" style={{ height: '60px', marginBottom: '16px', filter: 'brightness(0) invert(1)' }} />
          <p style={{ fontSize: '14px', lineHeight: 1.6, opacity: 0.7, marginBottom: '20px' }}>
            Productos que mejoran tu hogar y tu vida. Calidad garantizada con los mejores precios de Chile.
          </p>
          <div style={{ display: 'flex', gap: '12px' }}>
            {[
              { icon: <Instagram size={18} />, href: 'https://instagram.com/shucore.online' },
              { icon: <Facebook size={18} />, href: 'https://facebook.com/shucore' },
            ].map((s, i) => (
              <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" style={{
                background: 'rgba(255,255,255,0.1)',
                color: 'white',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                transition: 'background 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--green-mid)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Categories */}
        <div>
          <h4 style={{ color: 'white', fontWeight: 800, marginBottom: '16px', fontSize: '16px' }}>Categorías</h4>
          {['Mascotas', 'Hogar', 'Limpieza', 'Tecnología', 'Ofertas'].map(cat => (
            <a key={cat} href="#productos" style={{
              display: 'block',
              color: 'rgba(255,255,255,0.65)',
              textDecoration: 'none',
              marginBottom: '10px',
              fontSize: '14px',
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--orange-light)'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.65)'}
            >
              {cat}
            </a>
          ))}
        </div>

        {/* Info */}
        <div>
          <h4 style={{ color: 'white', fontWeight: 800, marginBottom: '16px', fontSize: '16px' }}>Información</h4>
          {['Sobre nosotros', 'Política de envíos', 'Devoluciones', 'Preguntas frecuentes', 'Términos y condiciones'].map(item => (
            <a key={item} href="#" style={{
              display: 'block',
              color: 'rgba(255,255,255,0.65)',
              textDecoration: 'none',
              marginBottom: '10px',
              fontSize: '14px',
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--orange-light)'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.65)'}
            >
              {item}
            </a>
          ))}
        </div>

        {/* Contact */}
        <div>
          <h4 style={{ color: 'white', fontWeight: 800, marginBottom: '16px', fontSize: '16px' }}>Contacto</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <a href="https://wa.me/56912345678" style={{ display: 'flex', gap: '10px', color: 'rgba(255,255,255,0.65)', textDecoration: 'none', fontSize: '14px' }}>
              <Phone size={16} style={{ flexShrink: 0, marginTop: '2px' }} />
              +56 9 1234 5678
            </a>
            <a href="mailto:contacto@shucore.online" style={{ display: 'flex', gap: '10px', color: 'rgba(255,255,255,0.65)', textDecoration: 'none', fontSize: '14px' }}>
              <Mail size={16} style={{ flexShrink: 0, marginTop: '2px' }} />
              contacto@shucore.online
            </a>
            <div style={{ display: 'flex', gap: '10px', fontSize: '14px' }}>
              <MapPin size={16} style={{ flexShrink: 0, marginTop: '2px' }} />
              Chile · Envíos a todo el país
            </div>
          </div>
        </div>
      </div>

      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.1)',
        paddingTop: '24px',
        textAlign: 'center',
        fontSize: '13px',
        opacity: 0.5,
      }}>
        © {new Date().getFullYear()} ShuCore.online · Todos los derechos reservados · Hecho con 💚 en Chile
      </div>
    </footer>
  );
}
